import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-how-to-purchase-a-registration',
  templateUrl: './how-to-purchase-a-registration.component.html',
  styleUrls: ['./how-to-purchase-a-registration.component.scss']
})
export class HowToPurchaseARegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
